import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import './Navbar.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import PopOver from '../PopOver/PopOver';
import { useAppContext } from '../../../context';
import logo from '../../../Assets/logo.jpeg';

const NavBar = () => {
    const { state: { user } } = useAppContext();
    const [isSticky, setSticky] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const handleNavClick = (callback) => {
        setExpanded(false);
        if (callback) callback();
    };

    return (
        <Navbar
            className={`navbar navbar-expand-lg navbar-light ${isSticky ? "navStyle" : "navDefault"}`}
            expand="lg"
            expanded={expanded}
            onToggle={(val) => setExpanded(val)}
        >
            <Container>
                <Navbar.Brand
                    as={Link}
                    to="/"
                    onClick={() => handleNavClick(scrollTop)}
                    className="navBrn"
                >
                    <div className="logoWrapper">
                        <img src={logo} alt="NextGen Nexus" className="navLogo" />

                        <div className="logoText">
    <span className="logoMain">
        <span className="logoNext">NextGen</span>
        <span className="logoNexus">Nexus</span>
    </span>

    <span className="logoSub">IT SOLUTIONS</span>
</div>
                    </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto mainNav" activeKey="/home">
                        <Nav.Item>
                            <Nav.Link
                                as={Link}
                                to="/"
                                className="nav-link"
                                onClick={() => handleNavClick(scrollTop)}
                            >
                                Home
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                href="#services"
                                className="nav-link"
                                onClick={() => handleNavClick()}
                            >
                                Services
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                href="#testimonial"
                                className="nav-link"
                                onClick={() => handleNavClick()}
                            >
                                Reviews
                            </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                            <Nav.Link
                                href="#contact"
                                className="nav-link"
                                onClick={() => handleNavClick()}
                            >
                                Contact Us
                            </Nav.Link>
                        </Nav.Item>

                        {user?.email &&
                            <Nav.Item>
                                <Nav.Link
                                    as={Link}
                                    to="/dashboard/profile"
                                    className="nav-link"
                                    onClick={() => handleNavClick()}
                                >
                                    Dashboard
                                </Nav.Link>
                            </Nav.Item>
                        }

                        <Nav.Item>
                            {user?.email ?
                                <div>
                                    <PopOver />
                                </div> :
                                <Link to="/login" onClick={() => handleNavClick()}>
                                    <button className="loginBtn">Login</button>
                                </Link>
                            }
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBar;